import styled from 'styled-components'

export const Content = styled.div`
  > div {
    display: flex;
    column-gap: 8px;
    margin-bottom: 16px;
  }
`
